/**
 * Test IDs for QA automation.
 */
export const testIds = {
  openingHoursFormDays: "opening-hours-form-days",
  openingHoursFormDayOption: "opening-hours-form-day-option",
  openingHoursFormDayToggle: "opening-hours-form-day-toggle",
  openingHoursFormRemoveSchedule: "opening-hours-form-remove-schedule",
  openingHoursFormAddSchedule: "opening-hours-form-add-schedule",
} as const;
